<template>
    <a-drawer :title="$t('program.unplanned_list_drawer_title' /* 已评审未排进日程文章 */)" width="85%" placement="right" :closable="true" :visible="visible" @close="handleDrawerClose">
        <a-form class="mb20" :form="form">
            <a-form-item>
                <a-checkbox-group v-decorator="['type_id']" @change="handleCheckboxEvent" class="filter-form">
                    <a-checkbox v-for="item in fayanList" :value="item.id" :key="item.id">{{ item['typename_' + $route.params.lang] }}</a-checkbox>
                </a-checkbox-group>
            </a-form-item>
        </a-form>

        <!-- 表格 -->
        <div class="t-r mb10">
            <a-button type="primary" @click="handleBatchRemoveEvent">{{ $t('program.batch_remove' /* 批量删除 */) }}</a-button>
        </div>
        <a-table
            ref="table"
            :rowKey="record => record.id"
            :columns="columns"
            :data-source="dataSource"
            :pagination="false"
            :scroll="{ x: 1000 }"
            :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange
            }"
        >
            <template slot="class_name" slot-scope="text">
                <div>{{ JSON.parse(text)[$route.params.lang] }}</div>
            </template>
        </a-table>
    </a-drawer>
</template>

<script>
export default {
    name: 'unplannedListDrawer',
    props: {
        fayanList: {
            type: Array,
            default: []
        }
    },
    components: {},
    data() {
        return {
            visible: false,
            selectedRowKeys: [],
            dataSource: [],
            queryParams: {
                type_id: ''
            },
            type_id: [],
            loading: false,
            form: this.$form.createForm(this),
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'left',
                    fixed: 'left',
                    width: 100
                },
                {
                    title: this.$t('web.class_name' /* 分类 */),
                    dataIndex: 'class_name',
                    scopedSlots: { customRender: 'class_name' },
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('program.title' /* 标题 */),
                    dataIndex: 'title',
                    align: 'left'
                },
                {
                    title: this.$t('program.real_name' /* 作者 */),
                    dataIndex: 'real_name',
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('web.company' /* 单位 */),
                    dataIndex: 'org_cnname',
                    align: 'left',
                    width: 200
                },
                {
                    title: this.$t('program.typename_cn' /* 录用类型 */),
                    dataIndex: 'typename_cn',
                    align: 'left',
                    width: 100
                }
            ]
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
        },
        //关闭抽屉
        handleDrawerClose() {
            this.selectedRowKeys = [];
            this.dataSource = [];
            this.queryParams.type_id = '';
            this.form.resetFields();
            this.visible = false;
        },
        // 多选框改变
        handleCheckboxEvent(checkedValues) {
            this.queryParams.type_id = checkedValues.join(',');
            this.getDataList();
        },
        // 复选框选中
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        // 获取列表数据
        getDataList() {
            this.loading = true;
            this.$request
                .get({ url: 'getNotProgramList', data: this.queryParams })
                .then(res => {
                    this.dataSource = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 批量删除
        handleBatchRemoveEvent() {
            if (!this.selectedRowKeys.length) {
                this.$message.warning(this.$t('web.un_select_del' /* 您还未选中要删除项 */));
                return false;
            }
            this.$confirm({
                title: this.$t('web.del_selected' /* 您确认要删除选中的吗？ */),
                content: this.$t('web.cannot_back' /* 被删除的数据将无法找回！ */),
                onOk: () => {
                    this.$request.post({ url: 'batchDelProgram', data: { abstract_ids: this.selectedRowKeys } }).then(res => {
                        this.$message.success(this.$t('web.del_success' /* 删除成功 */));
                        this.selectedRowKeys = [];
                        this.getDataList();
                    });
                },
                onCancel() {}
            });
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-checkbox-group {
    width: 100%;
}
.filter-form {
    background-color: #fafafa;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 10px 15px;
}
::v-deep .ant-drawer-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>